import React, { useState } from 'react';

const Header = () => {
  const [activeSection, setActiveSection] = useState('inicio');

  const handleNavigation = (section) => {
    setActiveSection(section);
    if (section === 'servicios') {
      document.getElementById('servicios').scrollIntoView({ behavior: 'smooth' });
    } else if (section === 'precios') {
      document.getElementById('precios').scrollIntoView({ behavior: 'smooth' });
    } else if (section === 'contacto') {
      document.getElementById('contacto').scrollIntoView({ behavior: 'smooth' });
    } else if (section === 'inicio') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <a 
              href="#" 
              className="flex items-center text-2xl font-bold text-gray-900"
              onClick={() => handleNavigation('inicio')}
            >
              {/* SVG del logo: un gráfico de barras o un libro de contabilidad */}
              <svg className="w-8 h-8 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
              Clerko
            </a>
          </div>
          <nav className="hidden md:flex space-x-8">
            <a 
              href="#" 
              className={`${activeSection === 'inicio' ? 'text-blue-600 font-medium' : 'text-gray-600'} hover:text-blue-600 transition-colors`}
              onClick={() => handleNavigation('inicio')}
            >
              Inicio
            </a>
            <a 
              href="#servicios" 
              className={`${activeSection === 'servicios' ? 'text-blue-600 font-medium' : 'text-gray-600'} hover:text-blue-600 transition-colors`}
              onClick={() => handleNavigation('servicios')}
            >
              Servicios
            </a>
            <a 
              href="#precios" 
              className={`${activeSection === 'precios' ? 'text-blue-600 font-medium' : 'text-gray-600'} hover:text-blue-600 transition-colors`}
              onClick={() => handleNavigation('precios')}
            >
              Precios
            </a>
            <a 
              href="#contacto" 
              className={`${activeSection === 'contacto' ? 'text-blue-600 font-medium' : 'text-gray-600'} hover:text-blue-600 transition-colors`}
              onClick={() => handleNavigation('contacto')}
            >
              Contacto
            </a>
          </nav>
          <button className="md:hidden text-gray-600">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;